export default __webpack_public_path__ + "static/media/fee-icon.cf9dc66c.svg";